/*
 * search query parameter from current url
 *
 * @paramName key
 * @return
 *   paramName == false: object include all params
 *   paramName != false: value for input paramName
 */
function getCurUrlParameter (paramName) {
  if (!paramName) {
    let result = {}
    if (!window) return result
    let searchString = window.location.search.substring(1)
    let params = searchString.split('&')
    for (let i = 0; i < params.length; i++) {
      let val = params[i].split('=')
      result[val[0]] = val[1]
    }
    return result
  } else {
    if (!window) return null
    let searchString = window.location.search.substring(1)
    let params = searchString.split('&')
    for (let i = 0; i < params.length; i++) {
      let val = params[i].split('=')
      if (val[0] === paramName) {
        return val[1]
      }
    }
    return null
  }
}

function isInApp () {
  return (this.getQueryString(window.location.href, 'deviceId') || !!navigator.userAgent.match(/org\.geekbang\.GeekTime/i))
  // his.getQueryString(window.location.href, 'deviceId')
}

function getQueryString (link, key) {
  let reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)', 'i')
  let queryString = link.split('?').length > 1 ? link.split('?')[1] : ''
  let r = queryString.match(reg)
  if (r !== null) return decodeURIComponent(r[2])
  return ''
}

export default {
  getCurUrlParameter,
  getQueryString,
  isInApp
}



// WEBPACK FOOTER //
// ./src/util/index.js